import { render, staticRenderFns } from "./RelatedArticlesField.vue?vue&type=template&id=3dc0f7fe&scoped=true&lang=pug&"
import script from "./RelatedArticlesField.vue?vue&type=script&lang=js&"
export * from "./RelatedArticlesField.vue?vue&type=script&lang=js&"
import style0 from "./RelatedArticlesField.vue?vue&type=style&index=0&id=3dc0f7fe&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc0f7fe",
  null
  
)

/* custom blocks */
import block0 from "./RelatedArticlesField.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports